import { determineCommModal } from 'ui-addon-upgrades/_core/contactSales/utils';
import { AssignableModal } from '../communicationMethods/AssignableModal';
import { RetailModal } from '../communicationMethods/RetailModal';
import UnassignableModal from '../communicationMethods/UnassignableModal';
import { COMM_METHODS_MODAL_TYPES } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
const CommModalContainer = ({
  handleClose,
  isFreePortal,
  isRetailPortal,
  isAssignable,
  modalRoot,
  upgradeData,
  repInfo,
  _overrideCommunicationMethodKey,
  _overrideModalHeaderText,
  isUpgradePoint,
  isGD0532ExperimentVariation
}) => {
  const commMethodsModalType = determineCommModal({
    repInfo,
    isRetailPortal,
    isAssignable
  });
  if (commMethodsModalType === COMM_METHODS_MODAL_TYPES.UNASSIGNABLE) {
    if (isRetailPortal) {
      return /*#__PURE__*/_jsx(RetailModal, {
        modalRoot: modalRoot,
        upgradeData: upgradeData,
        onClose: closeInfo => handleClose(closeInfo),
        isUpgradePoint: isUpgradePoint,
        isGD0532ExperimentVariation: isGD0532ExperimentVariation
      });
    }
    return /*#__PURE__*/_jsx(UnassignableModal, {
      modalRoot: modalRoot,
      upgradeData: upgradeData,
      onClose: closeInfo => handleClose(closeInfo),
      isUpgradePoint: isUpgradePoint,
      isGD0532ExperimentVariation: isGD0532ExperimentVariation
    });
  }
  if (commMethodsModalType === COMM_METHODS_MODAL_TYPES.ASSIGNABLE) {
    return /*#__PURE__*/_jsx(AssignableModal, {
      modalRoot: modalRoot,
      _overrideCommunicationMethodKey: _overrideCommunicationMethodKey,
      _overrideModalHeaderText: _overrideModalHeaderText,
      upgradeData: upgradeData,
      onClose: closeInfo => handleClose(closeInfo),
      isFreePortal: Boolean(isFreePortal),
      isUpgradePoint: isUpgradePoint,
      repInfo: repInfo,
      handleIframeSizeChange: () => {},
      isGD0532ExperimentVariation: isGD0532ExperimentVariation
    });
  }
  return null;
};
export default CommModalContainer;